import classNames from 'classnames'
import styles from './Table.module.css'
import type { CSSProperties, ReactNode } from 'react'

function Cell({
  children,
  className,
  as: Tag = 'td',
  maxWidth: maxWidth_,
  ...widths
}: {
  children: ReactNode
  className?: string
  width?: number
  maxWidth?: number
  minWidth?: number
  as?: 'th' | 'td'
}) {
  const cellClass = Tag === 'th' ? styles.headerCell : styles.cell
  const maxWidth = maxWidth_ === Number.POSITIVE_INFINITY ? undefined : maxWidth_
  return (
    <Tag
      className={classNames(cellClass, className)}
      style={{ ...widths, maxWidth, '--cell-width': widths.width } as CSSProperties}
    >
      {children}
    </Tag>
  )
}

export default Cell
